import React from 'react'
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Inject} from '@syncfusion/ej2-react-grids';
/*import { Button } from 'react-bootstrap';*/

//import './Requests.css';
//import UserRequestDetails from '../UserRequestDetails/UserRequestDetails';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { withAuth } from 'react-oidc-context';
//import { useAuth } from "react-oidc-context";
//import configData from "../../../src/config.json";
import ManageToken from '../../Token';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import LogoutUser from '../Logout/Logout';
import logger from '../../logger';


class Requests extends React.Component<any, any> {
    isAdmin = false;
    grid: any;
    token: any;
    rowSelected() {
        if (this.grid) {
            const selectedrecords = this.grid.getSelectedRecords();
            if (!selectedrecords || selectedrecords.length === 0 || !selectedrecords[0].requestID) {
                logger.warn("[Requests] Row selected but no valid request found.");
                return;
            }
            logger.info("[Requests] Opening request " + selectedrecords[0].requestID);
            //this.setState({ requestId: selectedrecords[0].requestID },
            //    () => { console.log(this.state.requestId) });
            this.props.navigation("/courseAssignment/detail/?requestId=" + selectedrecords[0].requestID, { state: { requestId: selectedrecords[0].requestID }, replace: true });
        }
    }
    deleteRequestDetails(requestId: Int32Array, selectedRow: number) {
        var deleteRequestURL = process.env.REACT_APP_SERVER_URL_DELETE_REQUEST ? process.env.REACT_APP_SERVER_URL_DELETE_REQUEST.toString() : "";
        if (!deleteRequestURL) {
            logger.error("[Requests] REACT_APP_SERVER_URL_DELETE_REQUEST is not configured.");
            alert("Application is not configured correctly. Please contact support.");
            return;
        }
        if (!this.token.GetToken()) {
            logger.error("[Requests] No access token available for delete.");
            alert("Your session has expired. Please sign in again.");
            return;
        }
        if (!window.confirm("Are you sure you want to delete this request?")) {
            return;
        }
        this.setState({
            deleteSpinnerHidden: false,
        })
        logger.info("[Requests] Deleting request " + requestId);
        const requestOptions = {
            method: "POST",
            headers: {
                "Authorization": "Bearer " + this.token.GetToken()
            }
        };
        const deleteData = async () =>

            await fetch(deleteRequestURL + requestId, requestOptions)
                .then(res => {
                    if (!res.ok) {
                        throw new Error("Delete failed with status " + res.status);
                    }
                    return res.json();
                })
                .then(
                    (result) => {
                        logger.info("[Requests] Request deleted: " + requestId);
                        this.setState({
                            deletedData: result,
                        });
                        if (selectedRow >= 0 && selectedRow !== undefined) {
                            var tempArr = [...this.state.requestDetails]
                            tempArr.splice(selectedRow, 1)
                            this.setState({ requestDetails: tempArr })
                        }
                        this.setState({
                            deleteSpinnerHidden: true,
                        })
                    },
                    (error) => {
                        logger.error("[Requests] Failed to delete request " + requestId, error);
                        alert("Unable to delete the request. Please try again later.");
                        this.setState({
                            deleteSpinnerHidden: true,
                        })
                    }
                )

        deleteData();
    }


    RefreshComponent = () => {
        window.location.reload();
    }
    public statusColTemplate: any = this.statusColumnTemplate;
    public statusColumnTemplate(props: any): any {
        return (
            <div className="row">

                <ButtonComponent cssClass='btn btn-primary btn btn-primary btn-sm'
                    onClick={(e: any) => this.submitRequest(e)}>Delete</ButtonComponent>

            </div>
        )
    }




    constructor(props: any) {

        super(props);
        this.token = new ManageToken();
        this.state = {
            requestDetails: [],
            deletedData: [],
            dataDisplaySpinnerHidden: true,
            deleteSpinnerHidden: true

        }

    }

    async componentDidMount() {
        this.setState({
            dataDisplaySpinnerHidden: false,
        })
        this.getRequestDetails();
    }

    submitRequest(e: any) {
        var selectedRow = 0;
        if (e.currentTarget.offsetParent?.parentElement?.ariaRowIndex !== undefined) {
            selectedRow = parseInt(e.currentTarget.offsetParent?.parentElement?.ariaRowIndex);
        }
        var seletcedVal = this.state.requestDetails[selectedRow - 1];
        if (!seletcedVal || !seletcedVal.requestID) {
            logger.error("[Requests] Unable to determine the selected request row.", selectedRow);
            return;
        }
        this.deleteRequestDetails(seletcedVal.requestID, selectedRow-1);
    }
    getRequestDetails() {
       
        //var getAllRequest = "https://localhost:7216/api/CreateNewRequest/GetRequestInfo";
        var getAllRequest = process.env.REACT_APP_SERVER_URL_GETALL_REQUEST ? process.env.REACT_APP_SERVER_URL_GETALL_REQUEST : "";
        //var bearerToken = "Bearer " + this.props.user.access_token; 
        const getData = async () =>
            await fetch(getAllRequest, {
                headers: {
                    "Authorization": "Bearer " + this.token.GetToken()
                }
            }).then(res => {
                if (!res.ok) {
                    throw new Error("Request list failed with status " + res.status);
                }
                return res.json();
            })
                .then(
                    (result) => {
                        if (!Array.isArray(result)) {
                            logger.error("[Requests] Unexpected response while loading requests.", result);
                            result = [];
                        }
                        this.setState({
                            requestDetails: result,
                        })
                        this.setState({
                            dataDisplaySpinnerHidden: true,
                        })
                    },
                    (error) => {
                        logger.error("[Requests] Failed to load requests.", error);
                        alert("Unable to load your requests. Please try again later.");
                        this.setState({
                            dataDisplaySpinnerHidden: true,
                        })
                    }
                )
        getData();
    }



    public render() {
        this.rowSelected = this.rowSelected.bind(this);
        return (
            <div>
                <div className="loading-indicator" hidden={this.state.dataDisplaySpinnerHidden}>
                    <div className="spinner-border text-primary">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                <div className="loading-indicator" hidden={this.state.deleteSpinnerHidden}>
                    <div className="spinner-border text-primary">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
                <Breadcrumbs route="/courseAssignment/requests" name="Course Enrollment" />
                <LogoutUser isAdmin={this.isAdmin} />
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2>My Requests</h2>
                            <hr></hr>
                            <Link to="/courseAssignment/create">
                                <button className="btn btn-primary">Create a new Request</button></Link>&nbsp;&nbsp;
                            <button className="btn btn-secondary"
                                onClick={this.RefreshComponent}>Refresh
                            </button>

                            <br /><br />

                            <GridComponent dataSource={this.state.requestDetails} rowSelected={this.rowSelected} allowPaging={true} ref={(g: any) => this.grid = g} >
                                <ColumnsDirective>

                                    <ColumnDirective field='requestName' headerText="Request Name" headerTextAlign="Left" width='120' textAlign="Left" />
                                    <ColumnDirective field='status' headerText="Status" headerTextAlign="Left" width='120' textAlign="Left" />
                                    <ColumnDirective field='createdDate' headerText="Created Date" headerTextAlign="Left" width='120' textAlign="Left" />
                                    <ColumnDirective field='userEmail' headerText="User Email" headerTextAlign="Left" width='150' textAlign="Left" />
                                    <ColumnDirective headerText="" template={this.statusColTemplate.bind(this)} headerTextAlign="Left" width='120' textAlign="Left" />
                                </ColumnsDirective>
                                <Inject services={[Page]} />
                            </GridComponent>

                        </div>
                    </div>
                </div>
            </div>
        );

    }


}
export function RequestsRouter() {
    const navigate = useNavigate();
    return (<Requests navigation={navigate} />);
}
export default withAuth(Requests)

